import React, { useEffect, useReducer, useState, useRef } from 'react';
import _ from 'lodash'
import ReactSelect from 'react-select';
import {
  Button,
  Col,
  Form, FormGroup,
  Input, Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap';

import Lang from 'Lang/General';
import {
  FormTabData,
  CompanyDataFormData,
  FormSampleData,
  SocialMediaData,
  PersonalFormData,
  ContactPersonFormData,
  InvoiceFormData
} from './assets';
import ResetPw from './ResetPw'
import DeleteConfirmationModal from 'components/Modal/deleteConfirmation'

const onHandleRoleVal = () => {
  if (window.location.hash.indexOf('consultants') > -1) {
    return 'CONSULTANT'
  }

  if (window.location.hash.indexOf('speakers') > -1) {
    return 'SPEAKER'
  }

  return `EXHIBITOR`
}

function IndustryForm({
  errors,
  data,
  countries,
  industries,
  fairs,
  onSubmit,
  onClose,
  selectedPortalUsers,
  clientID,
  updatingConfirmed,
  onChangePortalUsersHOC,
  resetPW
}) {
  const [currentTab, setCurrentTab] = useState('company_data')
  const [showRemoveFair, setRemoveFair] = useState(false)
  const [tempFairValue, setTempFairValue] = useState(null)
  const [showResetPw, setShowResetPW] = useState(false)
  const [formData, setFormData] = useState({
    ...FormSampleData,
    role: onHandleRoleVal(),
    client_id: clientID
  })

  const fairRef = useRef()

  useEffect(() => {
    if (selectedPortalUsers) {
      let tempIndustries = _.map(selectedPortalUsers.industries, child => {
        return _.find(industries, { id: child })
      })
      setFormData({
        ...selectedPortalUsers,
        status: updatingConfirmed ? 'CONFIRMED' : selectedPortalUsers.status,
        fairs: _.isEmpty(selectedPortalUsers.fairs) ? [] : _.map(selectedPortalUsers.fairs, item => ({
          id: item.id,
          label: item.title,
          value: item.title,
        })),
        industries: tempIndustries
      })

      onChangePortalUsersHOC('updatingConfirmed', false)
    }
  }, [selectedPortalUsers])

  useEffect(() => {
    if (!showRemoveFair) {
      fairRef.current && fairRef.current.blur()
    }
  }, [showRemoveFair])

  const onChangeField = (key, val) => {
    setFormData({
      ...formData,
      [key]: val
    })
  }

  const onHandleCopyInvoice = val => {
    let temp = _.cloneDeep(formData)
    temp.is_invoice_identical = val

    InvoiceFormData(countries).map(field => {
      temp[field.value] = temp[field.value_to_copy]
    })

    setFormData(temp)
  }

  const renderFormContent = (formChild) => {
    return (
      <Col key={formChild.value} lg={formChild.col} className={formChild.className || ''}>
        {
          formChild.type === 'checkbox' && (
            <FormGroup check>
              <Input
                type={'checkbox'}
                checked={formData[formChild.value]}
                onChange={e => onChangeField(formChild.value, e.target.checked)}
              />
              <Label check>
                {
                  Lang[formChild.label]
                    ? Lang[formChild.label][data.languageReducer.userSettings.admin_panel_language]
                    : formChild.label
                }
              </Label>
            </FormGroup>
          )
        }
        {
          formChild.type !== 'checkbox' && (
            <FormGroup>
              <Label className="d-flex mb-2 align-items-center">
                {
                  Lang[formChild.label]
                    ? Lang[formChild.label][data.languageReducer.userSettings.admin_panel_language]
                    : formChild.label
                }
                {
                  formChild.required && (
                    <span className="text-danger">{` *`}</span>
                  )
                }
              </Label>
              {
                formChild.type.indexOf('select') < 0 && (
                  <Input
                    type={formChild.type}
                    disabled={formChild.disabled || (currentTab === 'for_invoice' && formData.is_invoice_identical)}
                    value={formData[formChild.value]}
                    style={{
                      ... !_.isEmpty(errors) && errors[formChild.value] && {
                        borderColor: 'red'
                      }
                    }}
                    onChange={e => {
                      let temp = _.cloneDeep(formData)
                      temp[formChild.value] = e.target.value

                      if (formChild.value === 'email') {
                        temp.username = e.target.value
                      }

                      if (formData.is_invoice_identical) {
                        let tempFind = _.find(InvoiceFormData(countries), { value_to_copy: formChild.value })

                        if (tempFind)
                          temp[tempFind.value] = e.target.value
                      }

                      setFormData(temp)
                    }}
                  />
                )
              }
              {
                formChild.type === 'select' && (
                  <Input
                    type={formChild.type}
                    value={formData[formChild.value]}
                    style={{
                      ... !_.isEmpty(errors) && errors[formChild.value] && {
                        borderColor: 'red'
                      }
                    }}
                    onChange={e => {
                      if (e.target.value === 'SPEAKER') {
                        return setFormData({
                          ...formData,
                          role: e.target.value,
                          is_also_speaker: false,
                          is_multiple_brands: false,
                        })
                      }

                      onChangeField(formChild.value, e.target.value)
                    }}
                  >
                    <option value=""></option>
                    {
                      formChild.options.map(child => (
                        <option value={child.value}>{child.label}</option>
                      ))
                    }
                  </Input>
                )
              }
              {
                formChild.type === 'react-select' && (
                  <>
                    <ReactSelect
                      options={formChild.options}
                      ref={formChild.multiple ? fairRef : null}
                      isMulti={formChild.multiple}
                      isDisabled={formChild.disabled || (currentTab === 'for_invoice' && formData.is_invoice_identical)}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: !_.isEmpty(errors) && errors[formChild.value] ? 'red' : 'hsl(0,0%,80%)',
                        }),
                      }}
                      onChange={val => {
                        if (!formChild.multiple) {
                          let temp = _.cloneDeep(formData)
                          temp[formChild.value] = val.value

                          if (formData.is_invoice_identical && formChild.value === 'country') {
                            temp['country_invoice'] = val.value
                          }
                          return setFormData(temp)
                        } else {
                          if (
                            formData[formChild.value]?.[0] &&
                            (formData[formChild.value].length > (val?.[0] ? val.length : 0)) &&
                            formChild.value === 'fairs'
                          ) {
                            setTempFairValue(val)
                            setRemoveFair(true)
                          } else {
                            onChangeField(formChild.value, val)
                          }
                        }

                      }}
                      value={
                        formChild.multiple
                          ? formData[formChild.value]
                          : {
                            label: formData[formChild.value],
                            value: formData[formChild.value]
                          }
                      }
                      placeholder={formChild.placeholder ? Lang[formChild.placeholder][data.languageReducer.userSettings.admin_panel_language] : ''} />
                  </>
                )
              }
              {
                !_.isEmpty(errors) && errors[formChild.value] && (
                  <small className="text-danger">{errors[formChild.value]}</small>
                )
              }
            </FormGroup>
          )
        }
      </Col>
    )
  }

  const renderTabContent = () => {
    let temp = CompanyDataFormData(
      countries,
      data.languageReducer.userSettings.admin_panel_language,
      formData,
      industries,
      fairs
    )

    if (currentTab === 'personal_data') {
      temp = PersonalFormData(data.languageReducer.userSettings.admin_panel_language)
    }
    if (currentTab === 'contact_person') {
      temp = ContactPersonFormData
    }
    if (currentTab === 'social_media') {
      temp = SocialMediaData
    }
    if (currentTab === 'for_invoice') {
      temp = InvoiceFormData(countries)
    }

    return temp.map(formChild => renderFormContent(formChild))
  }

  return (
    <>
      <ModalHeader toggle={() => onClose()} >
        {Lang['UPDATE'][data.languageReducer.userSettings.admin_panel_language]}
      </ModalHeader>
      <ModalBody>
        <div className="d-flex p-2 mb-4 flex-wrap" style={{ gap: 10 }}>
          {
            FormTabData.map(child => (
              <Button
                color={currentTab === child.value ? 'primary' : 'secondary'}
                onClick={() => setCurrentTab(child.value)}
              >
                {Lang[child.label][data.languageReducer.userSettings.admin_panel_language]}
              </Button>
            ))
          }
        </div>
        <Form>
          <Row>
            {
              currentTab === 'for_invoice' && (
                <>
                  <Col lg={12}>
                    <FormGroup className={'mb-4'} check >
                      <Input
                        type={'checkbox'}
                        checked={formData.is_invoice_identical}
                        onChange={e => onHandleCopyInvoice(e.target.checked)}
                      />
                      <Label check>
                        {Lang['INVOICE_DATA_IDENTICAL'][data.languageReducer.userSettings.admin_panel_language]}
                      </Label>
                    </FormGroup>
                  </Col>
                </>
              )
            }
            {
              renderTabContent()
            }
            {
              currentTab === 'company_data' && (
                <>
                  <Col lg={6}>
                    <FormGroup>
                      <Label>
                        {Lang['USER_NAME'][data.languageReducer.userSettings.admin_panel_language]}
                      </Label>
                      <Input disabled={true} value={formData.username}></Input>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup>
                      <Label className={'d-flex flex-wrap align-items-end'}>
                        {Lang['PASSWORD'][data.languageReducer.userSettings.admin_panel_language]}
                        <Button
                          color={'primary'}
                          className={'ml-auto'}
                          size={'sm'}
                          onClick={() => setShowResetPW(true)}
                        >
                          {Lang['RESET_PW'][data.languageReducer.userSettings.admin_panel_language]}
                        </Button>
                      </Label>
                      <Input disabled={true}></Input>
                    </FormGroup>
                  </Col>
                </>
              )
            }
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={() => {
            onSubmit(({
              ...formData,
              industries: _.map(formData.industries, child => child.id),
              fairs: _.map(formData.fairs, child => child.id)
            }))
          }}>
          {Lang['SUBMIT'][data.languageReducer.userSettings.admin_panel_language]}</Button>
      </ModalFooter>
      <Modal
        isOpen={showResetPw}
        toggle={() => setShowResetPW(false)}
      >
        <ResetPw
          data={data}
          onClose={() => setShowResetPW(false)}
          formData={formData}
          selectedPortalUsers={selectedPortalUsers}
          onSubmit={resetPW}
          Lang={Lang}
        />
      </Modal>
      {
        showRemoveFair && (
          <DeleteConfirmationModal
            handleModalClose={() => setRemoveFair(false)}
            deleteOpen={showRemoveFair}
            confirmAction={() => {
              onChangeField('fairs', tempFairValue)
              setRemoveFair(false)
            }}
            content={Lang['REMOVE_FAIR_CONFIRMATION'][data.languageReducer.userSettings.admin_panel_language]}
            lang={data.languageReducer.userSettings.admin_panel_language}
          />
        )
      }
    </>
  )
}

export default IndustryForm